const KEY_TERM_LABELS: Record<string, string> = {
  targetRaise: 'Target raise',
  targetIrr: 'Target IRR',
  expectedIrr: 'Expected IRR',
  loanTerm: 'Loan term',
  targetHoldings: 'Target holdings',
  holdings: 'Holdings',
  hold: 'Hold period',
  minimum: 'Minimum',
  preferred: 'Preferred',
  geography: 'Geography',
  partner: 'Partner',
  focus: 'Focus',
  strategy: 'Strategy',
  product: 'Product',
  deployment: 'Deployment',
  structure: 'Structure',
  facility: 'Facility',
  collateral: 'Collateral',
  economics: 'Economics',
  perk: 'Perk',
  committed: 'Committed',
  available: 'Available',
};

/** Human label for fund frontmatter keyTerms keys (CSS may uppercase). */
export function formatKeyTermLabel(key: string): string {
  if (KEY_TERM_LABELS[key]) return KEY_TERM_LABELS[key];
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
